import { useRef, useState } from "react";
import axios, { AxiosRequestConfig } from "axios";

import Cookie from "js-cookie";

type ReturnType = {
  execute: (
    d?: { [key: string]: string } | FormData,
    newConfig?: AxiosRequestConfig
  ) => Promise<any>;
  cancel: () => void;
  loading: boolean;
};

const formDataMaker = (
  data: { [key: string]: string } | FormData
): FormData => {
  let fd: FormData;
  if (!(data instanceof FormData)) {
    fd = new FormData();
    if (typeof data !== "undefined") {
      Object.keys(data).forEach((key) => fd.append(key, data[key]));
    }
  } else {
    fd = data;
  }

  return fd;
};

const useAxios = (
  url: string,
  data?: { [key: string]: string } | FormData,
  configParams?: AxiosRequestConfig
): ReturnType => {
  const controller = useRef<AbortController>(new AbortController());

  const [loading, setLoading] = useState<boolean>(false);

  const cancel = () => {
    controller.current.abort();
    setLoading(false);
    controller.current = new AbortController();
  };

  const execute = async (
    d?: { [key: string]: string } | FormData,
    newConfig?: AxiosRequestConfig
  ) => {
    let fd: FormData;
    if (typeof d !== "undefined") {
      fd = formDataMaker(d);
    } else if (typeof data !== "undefined") {
      fd = formDataMaker(data);
    } else {
      fd = new FormData();
    }

    let token = Cookie.get("token");

    if (typeof token !== "undefined") {
      fd.append("usertoken", token);
    } else {
      fd.append("usertoken", "undefined");
    }

    let cp = { ...configParams };

    if (typeof newConfig !== "undefined") {
      cp = { ...cp, ...newConfig };
    }

    setLoading(true);
    return await axios
      .request({
        url,
        data: fd,
        signal: controller.current.signal,
        baseURL: "http://irancovercrmb.tatdemo.ir/",
        method: "POST",
        ...cp,
      })
      .then((res) => {
        setLoading(false);
        return res.data;
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };

  return { loading, execute, cancel };
};

export default useAxios;
